"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamMessagesSnapshotId = void 0;
var TeamMessagesSnapshotId = (function () {
    function TeamMessagesSnapshotId(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        if (typeof data === 'string') {
            if (!data.startsWith('TeamMessagesSnapshotId#')) {
                throw new Error('Identifier must start with TeamMessagesSnapshotId, got ' + data);
            }
            var parts = data.substr(data.indexOf('#') + 1).split(':');
            this.app = decodeURIComponent(parts[0]);
            this.id = decodeURIComponent(parts[1]);
        }
        else {
            this.id = data.id;
            this.app = data.app;
        }
    }
    TeamMessagesSnapshotId.prototype.getPackageName = function () { return TeamMessagesSnapshotId.PackageName; };
    TeamMessagesSnapshotId.prototype.getClassName = function () { return TeamMessagesSnapshotId.ClassName; };
    TeamMessagesSnapshotId.prototype.getFullClassName = function () { return TeamMessagesSnapshotId.FullClassName; };
    Object.defineProperty(TeamMessagesSnapshotId.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field id expects type string, got ' + value);
            }
            if (!value.match('^[0-9a-fA-f]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')) {
                throw new Error('Field id expects guid format, got ' + value);
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamMessagesSnapshotId.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field app expects type string, got ' + value);
            }
            if (!value.match('^[0-9a-fA-f]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')) {
                throw new Error('Field app expects guid format, got ' + value);
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    TeamMessagesSnapshotId.prototype.toString = function () {
        var suffix = encodeURIComponent(this.app) + ':' + encodeURIComponent(this.id);
        return 'TeamMessagesSnapshotId#' + suffix;
    };
    TeamMessagesSnapshotId.prototype.serialize = function () {
        return this.toString();
    };
    TeamMessagesSnapshotId.PackageName = 'net.playq.octopus2.tgservices';
    TeamMessagesSnapshotId.ClassName = 'TeamMessagesSnapshotId';
    TeamMessagesSnapshotId.FullClassName = 'net.playq.octopus2.tgservices.TeamMessagesSnapshotId';
    return TeamMessagesSnapshotId;
}());
exports.TeamMessagesSnapshotId = TeamMessagesSnapshotId;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register(TeamMessagesSnapshotId.FullClassName, {
    full: TeamMessagesSnapshotId.FullClassName,
    short: TeamMessagesSnapshotId.ClassName,
    package: TeamMessagesSnapshotId.PackageName,
    type: irt_1.IntrospectorTypes.Id,
    ctor: function () { return new TeamMessagesSnapshotId(); },
    fields: [
        {
            name: 'id',
            accessName: 'id',
            type: { intro: irt_1.IntrospectorTypes.Uid }
        },
        {
            name: 'app',
            accessName: 'app',
            type: { intro: irt_1.IntrospectorTypes.Uid }
        }
    ]
});
//# sourceMappingURL=TeamMessagesSnapshotId.js.map